export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/slowOverlay.worker.d792e814.worker.js");
}
